module.exports = __webpack_public_path__ + "img/PA.3723c6e6.svg";